import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { List, ListItem } from 'chaoskit/src/components'
import { gradient, text } from 'chaoskit/src/assets/styles/utility'

import Data from '~components/Data'

const GradientList = ({ items, ...rest }) => {
  const theme = useTheme()

  return (
    <List
      space="large"
      css={{
        '> li + li': {
          position: 'relative',

          '&::before': [
            gradient.tealGreen(theme),
            {
              content: "''",
              display: 'block',
              height: 2,
              marginBottom: theme.space.large,
            },
          ],
        },
      }}
      {...rest}
    >
      {items.map((item) => (
        <ListItem
          key={item.blurb}
          css={[
            item.heading && {
              color: theme.fontColor.muted,
            },

            !item.heading && [
              text.heading(theme),
              {
                fontSize: theme.fontSize.medium,
                fontWeight: theme.fontWeight.base,
                lineHeight: theme.lineHeight.base,
              },
            ],
          ]}
        >
          {item.heading && (
            <h5 css={theme.fontSize.large__fluid}>{item.heading}</h5>
          )}
          <div css={{ marginTop: theme.space.small }}>
            <Data>{item.blurb}</Data>
          </div>
        </ListItem>
      ))}
    </List>
  )
}

GradientList.propTypes = {
  items: PropTypes.array.isRequired,
}

export default GradientList
